import script from "./NoteDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./NoteDetail.vue?vue&type=script&setup=true&lang=js"

import "./NoteDetail.vue?vue&type=style&index=0&id=cd09fdf8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd09fdf8"]])

export default __exports__